import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateExchangeRates = (params) => {
    return axios.put(`${backendHost}/api/admin/exchange-rates`, params);
};

export {
    postUpdateExchangeRates
}